import React from 'react';
import { useImage } from 'common/hooks';

type Props = {
  readonly path: string;
  readonly onLoaded: (url: string) => React.ReactElement;
  readonly onError?: () => React.ReactElement;
  readonly onLoading?: () => React.ReactElement;
};

function LazyImage({
  path,
  onLoaded,
  onError,
  onLoading,
}: Props): React.ReactElement {
  const [url, isLoading, error] = useImage(path);

  if (error) return onError ? onError() : null;
  if (isLoading) return onLoading ? onLoading() : null;

  return onLoaded(url);
}

export default LazyImage;
